module.exports = __webpack_public_path__ + "img/logofinal.82105286.png";